// extracted by mini-css-extract-plugin
export default {"followButton":"fR-z","followCount":"gR-z","textStyle":"hR-z"};